module.exports = __webpack_public_path__ + "resources/img/facetec-ui-customizations-13.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/facetec-ui-customizations-13.png
// module id = 1388
// module chunks = 0